// extracted by mini-css-extract-plugin
export var equalColumn = "_fl-0";